export default __webpack_public_path__ + "static/media/bg-mask.b4855154.svg";